export function EmailPopUp(param){

    function openPopUp(){
        let idUser = param["data"]["id"];
        window.open(`/user/${idUser}`, "windowName", 'popup  width=1500,height=840');
    }

    return (
        <div onClick={openPopUp}>
        {param.value}
        </div>
    )
}